import * as React from "react";
import { useTranslation } from "react-i18next";
import { indicesInWarmTier, isSearchingWarmTier } from "views/components/searchbar/queryvalidation/warmTierValidation";
import { Explanation } from "views/components/searchbar/queryvalidation/QueryValidation";
import WarmTierErrorMessage from "views/components/searchbar/queryvalidation/WarmTierErrorMessage";
const WarmTierQueryValidation = ({ validationState }) => {
  const { t } = useTranslation("search");
  const warmTierIndices = indicesInWarmTier(validationState);
  if (!isSearchingWarmTier(warmTierIndices)) return null;
  return /* @__PURE__ */ React.createElement(Explanation, null, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("b", null, t("query_validation.warm_tier_title")), ": ", /* @__PURE__ */ React.createElement(WarmTierErrorMessage, { warmTierIndices })));
};
export default WarmTierQueryValidation;
